import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import * as Yup from 'yup';
import { Formik } from 'formik';
import { createUser, errorMessage } from "../../reducers/users";
import TitleCombobox from "./TitleCombobox";

const CreateUserModal = (props) => {
  const dispatch = useDispatch();
  const createErrorMessage = useSelector(errorMessage);

  const modalClose = () => {
    props.closeModal(false);
  }
    // Schema for yup
  const userValidationSchema = Yup.object().shape({
    firstname: Yup.string()
      .required("*First Name is required"),
    lastname: Yup.string()
      .required("*Last Name is required"),
    email: Yup.string()
      .required("*Email Address is required"),
    phone: Yup.string()
      .max(45, "*Phone Number can't be more than 45 characters"),
    zip: Yup.string()
      .min(5, "*Zip Code must be at least 5 digits")
      .max(10, "*Zip Code can't be more than 10 digits"),
    balance: Yup.number()
  });
  
/*  useEffect(() => {
     if(createSubmitStatus === 'succeeded') {
        props.closeModal(false);
     }
  }, [createSubmitStatus,props]);
*/
  return (
    <Modal show={props.show} onHide={modalClose}>
    <Modal.Header closeButton>
      <Modal.Title>Add User<br/></Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>
        The new user will be sent an email to confirm and complete registration.
      </p>
      <Formik
        initialValues={
            {
                firstname: "",
                lastname: "",
                email: "",
                phone: "",
                title: "",
                street1:"",
                street2: "",
                city:"",
                state:"",
                zip:"",
                balance: 0,
                balanceRollsOver: false
            }}
        validationSchema={userValidationSchema}
        onSubmit={(values, {setSubmitting, resetForm}) => {
            // When button submits form and form is in the process of submitting, submit button is disabled
            console.log("FORM VALUES", values);
            setSubmitting(true);
            dispatch(createUser(values));
            props.closeModal(false);
            // Resets form after submission is complete
            //resetForm();

            // Sets setSubmitting to false after form is reset
            setSubmitting(false);
        }}
        >
          {( {values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting }) => (
            <Form >
              <h3>User Information</h3>
              <Form.Group className="mb-3" controlId="firstname">
                <Form.Label>First Name</Form.Label>
                <Form.Control 
                  name="firstname"
                  type="text"
                  placeholder="First Name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.firstname}
                  className={touched.firstname && errors.firstname ? "error" : null}
                />
                {touched.firstname && errors.firstname ? (
                  <div className="error-message">{errors.firstname}</div>
                ): null}
              </Form.Group>
              <Form.Group className="mb-3" controlId="lastname">
                <Form.Label>Last Name</Form.Label>
                <Form.Control 
                  name="lastname"
                  type="text"
                  placeholder="Last Name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.lastname}
                  className={touched.lastname && errors.lastname ? "error" : null}
                />
                {touched.lastname && errors.lastname ? (
                  <div className="error-message">{errors.lastname}</div>
                ): null}
              </Form.Group>
              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  name="email"
                  type="text"
                  placeholder="Email Address"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.email}
                  className={touched.email && errors.email ? "error" : null}
                />
                {touched.email && errors.email ? (
                  <div className="error-message">{errors.email}</div>
                ): null}
              </Form.Group>
              <Form.Group className="mb-3" controlId="phone">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  name="phone"
                  type="tel"
                  placeholder="Phone Number"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.phone}
                  className={touched.phone && errors.phone ? "error" : null}
                />
                {touched.phone && errors.phone ? (
                  <div className="error-message">{errors.phone}</div>
                ): null}
              </Form.Group>
              <TitleCombobox
                name="title"
                value={values.title}
                onChange={handleChange}
                onBlur={handleBlur}
                className={touched.title && errors.title ? "error" : null}
              />
              <h3>Shipping Address</h3>
              <Form.Group className="mb-3" controlId="street1">
                <Form.Label>Street</Form.Label>
                <Form.Control 
                  name="street1"
                  type="text"
                  placeholder="Street"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.street1}
                  className={touched.street1 && errors.street1 ? "error" : null}
                />
                {touched.street1 && errors.street1 ? (
                  <div className="error-message">{errors.street1}</div>
                ): null}
              </Form.Group>
              <Form.Group className="mb-3" controlId="street2">
                <Form.Label>Apt / Suite Number</Form.Label>
                <Form.Control 
                  name="street2"
                  type="text"
                  placeholder="Apt / Suite Number"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.street2}
                  className={touched.street2 && errors.street2 ? "error" : null}
                />
                {touched.street2 && errors.street2 ? (
                  <div className="error-message">{errors.street2}</div>
                ): null}
              </Form.Group>
              <Form.Group className="mb-3" controlId="city">
                <Form.Label>City</Form.Label>
                <Form.Control 
                  name="city"
                  type="text"
                  placeholder="City"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.city}
                  className={touched.city && errors.city ? "error" : null}
                />
                {touched.city && errors.city ? (
                  <div className="error-message">{errors.city}</div>
                ): null}
              </Form.Group>
              <Form.Group className="mb-3" controlId="state">
                <Form.Label>State</Form.Label>
                <Form.Select
                  name="state"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.state}
                  className={touched.state && errors.state ? "error" : null}
                  >
                  <option value="">Select a State</option>
                  <option value="AL">Alabama</option>
                  <option value="AK">Alaska</option>
                  <option value="AZ">Arizona</option>
                  <option value="AR">Arkansas</option>
                  <option value="CA">California</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DE">Delaware</option>
                  <option value="DC">District Of Columbia</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="HI">Hawaii</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="IA">Iowa</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="ME">Maine</option>
                  <option value="MD">Maryland</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MS">Mississippi</option>
                  <option value="MO">Missouri</option>
                  <option value="MT">Montana</option>
                  <option value="NE">Nebraska</option>
                  <option value="NV">Nevada</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>
                  <option value="NY">New York</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>
                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VT">Vermont</option>
                  <option value="VA">Virginia</option>
                  <option value="WA">Washington</option>
                  <option value="WV">West Virginia</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WY">Wyoming</option>
                </Form.Select>
                {touched.state && errors.state ? (
                  <div className="error-message">{errors.state}</div>
                ): null}
              </Form.Group>

              <Form.Group className="mb-3" controlId="zip">
                <Form.Label>Zip Code</Form.Label>
                <Form.Control 
                  name="zip"
                  type="text"
                  placeholder="Zip Code"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.zip}
                  className={touched.zip && errors.zip ? "error" : null}
                />
                {touched.zip && errors.zip ? (
                  <div className="error-message">{errors.zip}</div>
                ): null}
              </Form.Group>
              <h3>Balance</h3>
              <Form.Group className="mb-3" controlId="balance">
                <Form.Label>Starting Balance</Form.Label>
                <Form.Control 
                  name="balance"
                  type="text"
                  placeholder="Starting Balance"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.balance}
                  className={touched.balance && errors.balance ? "error" : null}
                />
                {touched.balance && errors.balance ? (
                  <div className="error-message">{errors.balance}</div>
                ): null}
              </Form.Group>

              <Form.Group className="mb-3" controlId="balanceRollsOver">
                <Form.Label>Balance Rolls Over</Form.Label>
                <Form.Check 
                  name="balanceRollsOver"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.balanceRollsOver}
                  className={touched.balanceRollsOver && errors.balanceRollsOver ? "error" : null}
                />
              </Form.Group>

              <Modal.Footer>
                <Button variant="secondary" onClick={modalClose}>
                  Cancel
                </Button>
                <Button variant="primary" type="submit" onClick={handleSubmit} disabled={isSubmitting}>
                  Add User
                </Button>
                {createErrorMessage}
              </Modal.Footer>
            </Form>  
      )}
    </Formik>
    </Modal.Body>
    </Modal>
  );
};

export default CreateUserModal; 